// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__14M3m","title":"AfterImages90_title__2ORsB","images":"AfterImages90_images__1Lyv3"};